import { useContext } from 'react';

import { ControlSourceContext } from '../../lib/control-source';

/** Red T (teleop) or green P (policy) in the feed's corner. The parent must be positioned. */
export function ControlBadge() {
  const info = useContext(ControlSourceContext);
  if (info === null) return null;
  const teleop = info.source === 'teleop';
  return (
    <div
      title={teleop ? 'Teleop' : `Policy${info.checkpoint ? `: ${info.checkpoint}` : ''}`}
      className={`pointer-events-auto absolute bottom-2 left-2 z-10 flex h-6 w-6 items-center justify-center rounded border-2 bg-black/60 text-sm font-bold ${
        teleop ? 'border-red-500 text-red-500' : 'border-green-500 text-green-500'
      }`}
    >
      {teleop ? 'T' : 'P'}
    </div>
  );
}
